import React from 'react';
import {
  GradingQuestionAction,
  GradingQuestionActionType,
} from './GradingQuestionReducer';
import { Grid, Typography } from '@mui/material';

interface GradingQuestionInputProps {
  dispatch: React.Dispatch<GradingQuestionAction>;
  grade: number | null;
  maxGrade: number;
  questionIndex: number;
  gradable?: boolean;
}

const GradingQuestionInput: React.FC<GradingQuestionInputProps> = ({
  dispatch,
  maxGrade,
  grade,
  questionIndex,
  gradable = true,
}) => {
  const gradeChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: GradingQuestionActionType.UpdateGrade,
      payload: {
        questionIndex: questionIndex,
        grade: +e.target.value,
      },
    });
  };
  return (
    <Grid item sx={{ position: 'absolute', right: 0, top: 10 }}>
      <Grid container item flexDirection="row">
        {gradable ? (
          <input
            type="number"
            value={grade || 0}
            min={0}
            max={maxGrade}
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
            onChange={gradeChangeHandler}
          />
        ) : (
          <Typography
            align="left"
            variant="body1"
            component="h3"
            gutterBottom
            sx={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            {`${grade || 0}`}
          </Typography>
        )}
        <Typography
          align="left"
          variant="body1"
          component="h3"
          gutterBottom
          sx={{
            width: '7%',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
        >
          {`/${maxGrade}`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default GradingQuestionInput;
